/**
 *
 * @param title  系统名称
 * @param pageTitle 页面名称
 * @returns {string}
 */
export default function getPageTitle(title, pageTitle,inname = '掌上学') {
  if (pageTitle) {
    return `${pageTitle} - ${inname}`
  }
  return `${title}`
}
